import React, { useEffect, useState } from "react";
import { Layout, Result, Skeleton, theme } from "antd";
import AppLogo from "../../assets/images/PrefectosLogos.png";
import { useParams, useSearchParams } from "react-router-dom";
import { hideLoading, showLoading, useLoadingDispatch } from "../../context/loadingContext";
import Message from "../../Components/common/Message";
import AuthService from "../../Components/auth/AuthService";

const Auth = new AuthService();
const { Header, Content } = Layout;

const CustomerInvoice = () => {
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const privateKey = searchParams?.get("security_code");

  const [routeOrders, setRouteOrders] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [loadMessage, setLoadMessage] = useState("");
  const [type, setType] = useState("info");
  const [invoiceUrl, setInvoiceUrl] = useState(null);
  const [iframeLoading, setIframeLoading] = useState(true); // New state for iframe loading

  const layoutDispatch = useLoadingDispatch();
  const { token: { colorBgContainer, borderRadiusLG } } = theme.useToken();

  const viewInvoice = (route_orders) => {
    const fileUrl = `https://5615243.extforms.netsuite.com/app/site/hosting/scriptlet.nl?script=1565&deploy=1&invoiceid=${route_orders[0]?.inv_internal_id}&formid=221&compid=5615243&ns-at=AAEJ7tMQyJ9EQ_rH6lf8EfJ7AmF0qqBANMlsTQMI4Ia7fT7dlyg`;
    setInvoiceUrl(fileUrl);
  };

  useEffect(() => {
    const fetchData = async () => {
      showLoading(layoutDispatch);
      setIsLoading(true);
      try {
        const res = await Auth.fetch(`/p/customer-order?security_code=${id}`);
        if (res?.ack && res?.route_pallets.length > 0) {
          const route_orders = [];
          res.route_pallets.forEach((rp) => {
            if (Number(rp.internal_id) > 0) {
              let order = route_orders.find(ro => ro.internalId === rp.internal_id);
              const orderItem = {
                itemPalletId: rp.item_pallet_id,
                itemCode: rp.item_id,
                itemName: rp.item_name,
                quantity: rp.quantity,
                unitPrice: Number(rp.gross_amount_incl_tax) / Number(rp.quantity),
                customerDeliveredQuantity: rp.customer_delivered_quantity,
                customerDeliveryStatus: rp.customer_delivery_status,
              };
              if (order) {
                order.orderWeight += Number(rp.item_total_weight);
                order.orderValue += Number(rp.gross_amount_incl_tax);
                order.items.push(orderItem);
              } else {
                route_orders.push({
                  rank: rp.rank,
                  internalId: rp.internal_id,
                  orderPalletId: rp.order_pallet_id,
                  delivered: rp.delivered,
                  deliveryDiscount: Number(rp.delivery_discount),
                  customerNotes: rp.customer_notes,
                  customerSignature: rp.customer_signature,
                  customerReceivedBy: rp.customer_received_by,
                  customerFiles: rp.customer_files,
                  customerName: rp.customer_project_id,
                  customerCode: rp.customer_name,
                  invoiceNo: rp.invoice_no,
                  inv_internal_id: rp.inv_internal_id,
                  saleOrderNo: rp.sale_order_no,
                  terms: rp.terms,
                  postCode: rp.ship_zip,
                  address: rp.ship_address1,
                  orderWeight: Number(rp.item_total_weight),
                  orderValue: Number(rp.gross_amount_incl_tax),
                  route_status_id: rp.route_status_id,
                  delivery_discount_req_status: rp.delivery_discount_req_status,
                  terms: rp.terms,
                  customer_internal_id: rp.customer_internal_id,
                  items: [orderItem],
                });
              }
            }
          });
          route_orders.sort((a, b) => a.rank - b.rank);
          setRouteOrders(route_orders);
          viewInvoice(route_orders);
        } else {
          setLoadMessage(res?.message);
          setType("error");
        }
      } catch (err) {
        console.log(err);
      } finally {
        hideLoading(layoutDispatch);
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  return (
    <Layout>
      <Header 
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 1,
        width: '100%',
        display: 'flex',
        alignItems: 'center',
      }}
      // style={{ position: "sticky", top: 0, zIndex: 1, width: "100%", display: "flex", alignItems: "center" }}
      >
        <div style={{ display: "flex" }} className="demo-logo">
          <img style={{ height: "36px" }} src={AppLogo} alt="appIcon" />
        </div>
      </Header>
      <Content style={{ padding: "0", height: "92vh" }}>
        <div style={{ padding: 0, minHeight: "92vh", background: colorBgContainer, borderRadius: borderRadiusLG }}>
          {isLoading ? (
            <>
              <Skeleton active />
              <Skeleton active />
              <Skeleton active />
              <Skeleton active />
            </>
          ) : routeOrders?.length > 0 ? (
            <div>
              {iframeLoading && (
                <>
                <Skeleton active />
                <Skeleton active />
                <Skeleton active />
                <Skeleton active />
                </>
                )} 
              {invoiceUrl && (
                <iframe
                  src={`https://docs.google.com/viewer?url=${encodeURIComponent(invoiceUrl)}&embedded=true`}
                  width="100%"
                  height="100%"
                  title="Invoice PDF"
                  style={{ border: "none", minHeight: "92vh", maxHeight: "100vh" }}
                  onLoad={() => setIframeLoading(false)} 
                />
              )}
            </div>
          ) : (
            <Result status="500" title="Invalid Request" subTitle="Sorry, no record found." />
          )}
          <Message type={type} msg={loadMessage} />
        </div>
      </Content>
    </Layout>
  );
};

export default CustomerInvoice;
